import type { PreloadFallbackProps } from '@/lib/page-designer/preload-fallback-registry';
import { Skeleton } from '@/components/ui/skeleton';

// oxlint-disable-next-line react/only-export-components -- synchronous fallback discovery reads this metadata export
export const componentTypeIds = ['SFN_Content.takeoverToggle', 'SFN_Content.takeoverToggleLogo'] as const;

export default function TakeoverTogglePreloadFallback({ component }: PreloadFallbackProps) {
    if ((component.data as { enabled?: boolean } | undefined)?.enabled === false) return null;

    return (
        <div
            data-slot="component-preload-fallback"
            data-component-type={component.typeId}
            className="flex min-h-14 w-full items-center justify-center gap-2 px-4"
            aria-hidden="true">
            <Skeleton className="h-4 w-24" />
            <Skeleton className="h-6 w-11 rounded-full" />
            <Skeleton className="h-4 w-28" />
        </div>
    );
}
